




























































import {Component, PropSync, Watch} from 'vue-property-decorator'
  import {Getter, Action} from "vuex-class";
  import BaseFilter from "@/components/Filter/BaseFilter";
  import {TemplateParamFilter} from "@/store/settings/template_params/types";
  import {SelectWings, ToggleWings, InputWings} from "wings-ui-components";
  import {notifyError} from "@/utils/notify-helper";
  import {getTranslatedParams} from "@/utils/notify-utils";

  @Component({components: {SelectWings, ToggleWings, InputWings}})
  export default class TemplateParamsFilter extends BaseFilter<TemplateParamFilter>{
    @PropSync('filterProp') filterParent!: any;
    @PropSync('runFilter') run!: any;
    @PropSync('show') is_show!: boolean;
    @Getter("transports") transportsList: any;

    @Action("getTemplateParams") actionGetTemplateParams: any;
    @Action("getPartners") actionGetPartners: any;
    @Action("getTransports") actionGetTransports: any;

    defaultFilter(): TemplateParamFilter {
      return {
        id: undefined,
        name: undefined,
        transport: undefined,
        page_number: 1
      }
    }

    partnersList: any = []

    async getPartnersList(filter: any) {
      const items = await this.actionGetPartners(filter);
      this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
    }

    created() {
      this.actionGetTransports();
      this.filtered();
      this.scroll();
    }

    async onFilteredAction(nextPage = false) {
      if (!nextPage) this.filter.page_number = 1;
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Additional template param",
          addititional_info: getTranslatedParams(this.filter)
        };
        const resp = await this.actionGetTemplateParams(this.filter);
        await this.actionLog(this.logObject);
        this.is_last = resp.length == 0;
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(err);
      } finally {
        this.moreLoading = false;
      }
    }

    @Watch('filter', {immediate: true, deep: true})
    onFilterChanged(val: TemplateParamFilter) {
      this.filterParent = val;
    }

    @Watch('run')
    onRunFilter(val: boolean) {
      if (!val) return;
      this.filtered();
      this.run = false;
    }
  }
